<template>
<kt-link class="kt-nav__link">
    <slot></slot>
</kt-link>
</template>

<script>
export default {

}
</script>